import { CommonService } from './../../../product/shared/services/common.service';
// import { MetaDataService } from '../../../shared/services/meta-data.service';
import { ConnectionService } from '@app/shared/services/connection.service';
import { FormBuilder } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from '@angular/router';
import { LayoutService } from '@app/shared/services/layout.service';
import {
  Component,
  Injector,
  OnInit,
  OnDestroy,
  ViewChild,
  ContentChild,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { MediaHolderComponent } from '@app/MediaHolder/MediaHolder.component';
import { CustomAttributesComponent } from '@app/forms/custom-attributes/custom-attributes.component';
import { MediaService } from '@app/shared/services/Media.service';
import { AttributeService } from '@product/shared/services/attribute-service.service';
import { ConfigurationService } from '@app/management/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@app/shared/services/Language.service';
import { ProductCatalogService } from '@app/shared/services/product-catalog.service';
import { CategoryService } from '@app/shared/services/Category.service';

@Component({
  selector: 'app-base-component',
  template: '',
})
export class BaseComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  isLoading = true;
  protected layoutService: LayoutService;
  protected router: Router;
  protected message: NzMessageService;
  protected route: ActivatedRoute;
  protected fb: FormBuilder;
  protected connectionService: ConnectionService;
  protected drawerService: NzDrawerService;
  // protected metaService: MetaDataService;
  protected notification: NzNotificationService;
  protected mediaService: MediaService;
  protected attributesService: AttributeService;
  protected commonService: CommonService;
  protected configurationService: ConfigurationService;
  protected translate: TranslateService;
  protected languageService: LanguageService;
  protected productCatalogService:ProductCatalogService;
  protected categoryService:CategoryService;
  constructor(injector: Injector) {
    this.commonService = injector.get(CommonService);
    this.configurationService = injector.get(ConfigurationService);
    this.attributesService = injector.get(AttributeService);
    this.mediaService = injector.get(MediaService);
    this.layoutService = injector.get(LayoutService);
    this.router = injector.get(Router);
    this.message = injector.get(NzMessageService);
    this.route = injector.get(ActivatedRoute);
    this.fb = injector.get(FormBuilder);
    this.connectionService = injector.get(ConnectionService);
    this.drawerService = injector.get(NzDrawerService);
    this.notification = injector.get(NzNotificationService);
    this.translate=injector.get(TranslateService);
    this.languageService=injector.get(LanguageService);
    this.productCatalogService=injector.get(ProductCatalogService);
    this.categoryService=injector.get(CategoryService)
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }

  submit() {
    this.mediaService.submitMedia$.emit();
  }
}
